export default "__VITE_ASSET__gMrfjaKw__"